import { AfterViewInit, Component, ElementRef, inject, Input, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-auth-shell',
  templateUrl: './auth-shell.component.html',
  styleUrls: ['./auth-shell.component.scss'],
  imports: [RouterLink]
})
export class AuthShellComponent implements AfterViewInit, OnDestroy {

  @Input()
  mode: 'signin' | 'signup' | 'reset' | 'confirm' = 'signin';

  private element = inject(ElementRef<HTMLElement>);
  private driftTimers: ReturnType<typeof setTimeout>[] = [];

  ngAfterViewInit(): void {
    const floaters = this.element.nativeElement.querySelectorAll('[data-float]');
    floaters.forEach((node, i) => this.driftLoop(node as unknown as HTMLElement, i));
  }

  ngOnDestroy(): void {
    this.driftTimers.forEach(t => clearTimeout(t));
  }

  // Organic, non-repeating floating motion for the background scene's decorative elements -
  // a random walk within a bounding range, each leg a random duration, so it never looks like
  // a fixed loop (unlike the CSS spin/pulse/drift keyframes used elsewhere in this scene,
  // which are fine to repeat exactly since they're subtler/faster).
  private driftLoop(el: SVGElement | HTMLElement, seed: number): void {
    const [rx, ry] = (el.getAttribute('data-float-range') || '80,80').split(',').map(Number);
    // Some floaters (e.g. the nutrition-facts card) have their own resting CSS transform
    // (a fixed rotation) - preserve it so the drift doesn't overwrite/undo it.
    const base = el.getAttribute('data-float-base') || '';

    const step = () => {
      const dx = (Math.random() * 2 - 1) * rx;
      const dy = (Math.random() * 2 - 1) * ry;
      // Long, leisurely, varied legs - short/uniform durations are what made the old
      // version read as mechanical ("predictable") despite the random target (#1742).
      const duration = 14 + Math.random() * 18;
      el.style.transition = `transform ${duration}s cubic-bezier(.42,.02,.58,.98)`;
      el.style.transform = `translate(${dx.toFixed(1)}px, ${dy.toFixed(1)}px) ${base}`;
      this.driftTimers.push(setTimeout(step, duration * 1000));
    };

    this.driftTimers.push(setTimeout(step, seed * 220 + Math.random() * 900));
  }
}
